export default {
    resalesLanding: {
        sentOn: "Sendt den",
        toggleContact: "Vis/skjul mæglerens kontaktoplysninger",
        propertyOffers: "Boligtilbud",
        openGallery: "Åbn fotogalleri",
        prevPhoto: "Forrige billede",
        nextPhoto: "Næste billede",
        close: "Luk",
        photo: "Billede",
        description: "Beskrivelse",
        more: "Mere",
        less: "Mindre",
        intFloorSpace: "Boligareal",
        build: "Bebygget",
        terrace: "Terrasse",
        garden: "Have",
        buildYear: "Byggeår",
        fees: "Omkostninger",
        communityFees: "Fællesudgifter",
        basuraTax: "Renovationsafgift (Basura)",
        ibiFees: "IBI (ejendomsskat)",
        securityDeposit: "Depositum",
        perMonth: "/måned",
        perWeek: "/uge",
        disclaimer: "Ansvarsfraskrivelse",
        energyCertificate: "Energimærke",
        pending: "Afventer",
        rating: "Klassificering",
        presentedBy: "Præsenteret af",
        propertyDetails: "Boligdetaljer",
        reference: "Reference",
        referenceShort: "Ref",
        unitUnavailable: "Ikke længere tilgængelig",
        availableUnits: "Ledige enheder og priser",
        availableUnitsShort: "Ledige enheder",
        unit: "Enhed",
        type: "Type",
        floors: "Etager",
        bedrooms: "Sovev.",
        bathrooms: "Bad",
        surfaceArea: "Indvendigt",
        price: "Pris",
        status: "Status",
        unitAvailable: "Ledig",
        unitReserved: "Reserveret",
        unitSold: "Solgt",
        seeMore: "Se mere",
        seeLess: "Se mindre",
        floor: "Etage",
        storeys: "Etager i alt",
        keyReady: "Indflytningsklar",
        touristLicence: "Turistlicens",
        firstOccupationLicence: "Ibrugtagningstilladelse",
        notKnown: "Ikke oplyst",
        notProvided: "Ikke angivet",
        yes: "Ja",
        no: "Nej",
        mortgageAvailable: "Finansiering mulig",
        guaranteedRental: "Garanteret udlejning",
        sellBeforeCompletion: "Overdragelse af kontrakten før færdiggørelse",
        sellBeforeCompletionYes: "Tilladt",
        sellBeforeCompletionNo: "Ikke tilladt",
        sellBeforeCompletionNotProvided: "Ikke oplyst",
        reservation: "Reservation",
        contract: "Kontrakt",
        construction: "Byggeri",
        completion: "Færdiggørelse",
        co2: "CO2",
        energyConsumption: "Energiforbrug",
        co2PerYear: "kg CO2/år",
        kwhPerYear: "kWh/år",
        features: "Faciliteter",
        viewDetails: "Se detaljer",
        hideDetails: "Skjul boligdetaljer",
        backToResults: "Resultater",
        viewProperty: "Se bolig",
        prevProperty: "Forrige",
        nextProperty: "Næste",
        viewAllFeatures: "Se alle faciliteter",
        allFeatures: "Alle faciliteter",
        infoOnRequest: "Oplysninger efter forespørgsel",
        tbc: "Ikke oplyst",
        featureCategoryLabels: { pool: "Pool", views: "Udsigt", parking: "Parkering", kitchen: "Køkken", condition: "Stand", garden: "Have" },
        featureQualifierFormat: "{value} {category}",
        location: "Beliggenhed",
        agencyInformation: "Oplysninger om mægleren",
        buyingCosts: "Købsomkostninger",
        propertyPrice: "Boligpris:",
        priceNote: "**Prisen er ekskl. skatter og købsomkostninger.",
        estimatedPurchaseCosts: "Anslåede købsomkostninger:",
        hide: "Skjul",
        showBreakdown: "Vis specifikation af købsomkostninger",
        purchaseCostBreakdown: "Specifikation af købsomkostninger",
        concept: "Post",
        application: "Beregning",
        rowTransferTax: "ITP (overdragelsesafgift, eksisterende bolig)",
        rowVat: "Moms (nybyggeri)",
        rowVatLand: "Moms",
        vatApplication: "10 % (4 % for almene boliger)",
        rowStampDuty: "Stempelafgift (AJD)",
        rowNotary: "Notar",
        rowLandRegistry: "Tingbog",
        officialTariff: "Officiel takst",
        costRangeNotePrefix: "*Køberens samlede omkostninger ligger typisk mellem",
        and: "og",
        ofPurchasePrice: "af købsprisen.",
        costApproxNote: "*De anslåede købsomkostninger er kun vejledende. De faktiske omkostninger kan variere afhængigt af ejendommen og køberens forhold. Vi anbefaler at søge professionel rådgivning for en nøjagtig beregning.",
        additionalInformation: "Yderligere oplysninger",
        addInfoDocument: "*Forkortet informationsdokument tilgængeligt i henhold til det andalusiske dekret 218/2005",
        addInfoNoFees: "*Køber betaler ikke mæglersalær",
        formHeading: "Vil du vide mere om priserne og boligen?",
        firstName: "Fornavn",
        enterNumber: "Indtast nummer",
        email: "E-mail",
        searchCountry: "Søg efter land eller landekode",
        noMatches: "Ingen resultater",
        consent: "Ved at klikke på knappen giver du samtykke til behandlingen af dine personoplysninger i henhold til privatlivspolitikken, herunder indsamling, opbevaring og brug af de angivne oplysninger med henblik på at kontakte dig og give dig de nødvendige oplysninger.",
        send: "Send",
        contactUs: "Kontakt os",
        yourMessage: "Din besked",
        agreeData: "Jeg accepterer at afgive mine oplysninger med det formål at modtage svar på min informationsforespørgsel.",
        agreeContact: "Jeg ønsker at blive informeret og accepterer at blive kontaktet af den virksomhed, der er ansvarlig for projektet, eller den relevante forhandler, via de kontaktoplysninger, som jeg frivilligt afgiver til dette formål.",
        reject: "Afvis",
        like: "Synes godt om",
        liked: "Gemt",
        rejected: "Afvist",
        offerRejected: "Tilbud afvist",
        contact: "Kontakt",
        call: "Ring",
        calling: "Ringer til",
        noPhone: "Intet telefonnummer tilgængeligt",
        enquirySent: "Forespørgsel sendt — vi kontakter",
        yourDetails: "dine oplysninger",
        respondedTo: "besvaret",
        noProperties: "Ingen boliger at vise.",
        soldOutBody: "Ejendommene i dette tilbud er solgt eller ikke længere til salg. Kontakt venligst bureauet for et opdateret udvalg.",
        expiredTitle: "Dette tilbudslink er udløbet",
        expiredBody: "Kontakt venligst mægleren for at få et opdateret link til at se disse boliger.",
        unavailableTitle: "Tilbud ikke tilgængeligt",
        unavailableBody: "Vi kunne ikke indlæse dette tilbud. Linket er muligvis ugyldigt, eller tjenesten er midlertidigt utilgængelig — prøv igen senere, eller kontakt mægleren.",
    },
    title: "{agencyName}'s egenskaber",
    in: "in",
    propertiesFound: "ejendomme fundet",
    toDay: "I dag",
    days: "dage",
    week: "Uge",
    year: "År",
    month: "Måned",
    prev: "Forrige",
    next: "Næste",
    backToList: "Tilbage til listen",
    sorry: "Undskyld, vi",
    cantFind: "kan ikke finde",
    lookingFor: "den side, du leder efter ...",
    thankYou: "TAK FOR BESØG VORES WEBSITE",
    pleaseContact: "Kontakt agenten for en ny URL.",
    ForSale: "SALG",
    ShortTermRental: "Kort leje",
    LongTermRental: "Lang leje",
    showMore: "Vis mere",
    showLess: "Vis mindre",
    price: "Pris",
    pricePer: "Pris pr.",
    built: "Samlede boligareal",
    floorSpace: "Indvendig boligareal",
    terrace: "Terrasse",
    garden: "Have",
    plot: "Grundstykke",
    propTitle: '{subType} {searchType} i {location}',
    propTitleShort: '{subType} i {location}',
    notAvailable: "Ikke tilgængelig",
    notFound: 'Side ikke fundet',
    emptyProperties: "Ingen ejendomme blev fundet. Kontakt din agent for mere information.",
    linkExpired: "Ups, dette link er udløbet. Kontakt din ejendomsmægler for at modtage et opdateret ejendomslink.",
    newDevelopment: "Ny udvikling",
    agencyRaiiNo: "Agenturets registreringsnummer",
    home: {
        verifyYourURLHere: "Bekræft din URL her. For at gøre dette skal du logge ind på WhatsApp i din webbrowser og derefter kopiere URL'en fra WhatsApp til her.",
        pasteUrlHere: "Indsæt URL her",
        verifyUrl: "Bekræft URL",
        whatIsPropertyViewer: "Hvad er Property-Viewer.com?",
        thisIsWebsiteIsUsed: "Dette websted bruges af ejendomsmæglere til at sende ejendomme til deres kunder. Det er et produkt fra {resalesonlinecom} Hvis du er i tvivl, bedes du tale med agenten, der sendte din ejendomsliste til dig.",
        howDoesItWork: "Hvordan virker det?",
        inThePast: "Tidligere ville Agenter sende PDF-dokumenter til deres kunder. Men disse er ikke nemme at se på mange enheder. Derfor har vi {propertyviewercom}, så klienten lettere kan få vist egenskaber, der er sendt til dem.",
        createAShortList: "Agenten opretter en kort liste over egenskaber. Når de deler disse egenskaber med dig, vil du modtage et link. Hvis du klikker på dette link vil vise dig de egenskaber."
    },

    searchType: {
        ForSale: "til salg",
        ShortTermRental: "til korttidsleje",
        LongTermRental: "til langtidsleje",
    },

    rsStatus: {
        Available: "Tilgængelig",
        Listing: "Notering",
        UnderOffer: "Under tilbud",
        SaleAgreed: "Salg aftalt",
        OffMarket: "Uden for markedet",
        Sold: "Solgt",
        Rented: "Lejet"
    },


    list: {
        propertyTitle: "Klik her for at få vist oplysninger om denne egenskab"
    },

    details: {
        average: "Gennemsnit",
        averagePricesFor: "Gennemsnitlige priser for",
        showFullER: "Vis fuld",
        thisProperty: "Denne ejendom",
        infoNotAvailable: "Disse oplysninger er ikke tilgængelige.",
        feesEnergyRating: "Gebyrer, energivurdering",
        fees: "Gebyrer",
        ibiFees: "Ejendomsskat",
        basuraTax: "Affalds skat",
        communityFees: "Fællesudgifter",
        associatedCosts: "Tilknyttede omkostninger",
        energyRating: "Energimærkning",
        securityDeposit: "Depositum",
        energyCertificate: "Energimærke",
        energyCertificatePending: "Afventer energimærke",
        energyConsumption: "Energiforbrug",
        co2: "CO₂",
        co2PerYear: "kgCO₂/m² pr. år",
        kwhPerYear: "kWh/m² pr. år",
        other: "Andre",
        buildYear: "Byggeår",
        forSale: "Til salg",
        sold: "Solgt",
        longTerm: "Langsigtet",
        shortTermHigh: "Short term high",
        shortTermLow: "Kortvarig lav",
        allFeatures: "Alle funktioner",
        aproxLocation: "Aprox. Placering",
        listingAgent: "Noteringsagent",
        notIncludeExpensesAndTaxes: "El precio no incluye gastos ni tributos. Los gastos adicionales al precio por parte del comprador son: Vivienda nueva/1ª transmisión Impuesto sobre el Valor Añadido (IVA) 10% (o 4% en caso de vivienda protegida); o en el caso de 2ª y/o posteriores transmisiones Impuesto sobre Transmisiones (ITP) según normativa autonómica vigente. Además, la formalización en documento público del contrato de compraventa (escrituras) podrá estar sujeta a AJD (Actos Jurídicos Documentados) según normativa aplicable, así como gastos de inscripción en el Registro y notaría. Información precontractual disponible conforme a la normativa aplicable en la Comunidad Autónoma correspondiente.",
        rentalLicenseRef: "Turistregistreringsnummer",
        agencyInformation: "Oplysninger om ejendomsmægleren",
    },
};